// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1479":"academy2","3983":"learn","9155":"arcade"}[chunkId] + "." + {"1479":"ba8a9ba8","3983":"ba8a9ba8","9155":"ba8a9ba8"}[chunkId] + ".chunk.css";
};